import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import _ from "lodash";
import { getByIdClient } from "src/thunks/clientProjects";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import IconAddProject from "src/assets/images/icon_newrecord.svg";
import IconKey from "src/assets/images/icon_key.svg";
import IconLock from "src/assets/images/icon_lock.svg";
import IconEditRecord from "src/assets/images/icon_editrecord.svg";
import IconRemove from "src/assets/images/icon_remove.svg";
import { CommonModal } from "src/components/modal";
import { UnlistClientForm } from "./unlistClientForm";
import { UnlistProjectForm } from "./unlistProjectForm";
import { GrantAppAccessForm } from "./grantAppAccessForm";
import { RevokeAppAccessForm } from "./revokeAppAccessForm";
import { AddProjectForm } from "./addProject";
import { AddClientForm } from "./addClientForm";
import { Loader } from "src/components/loader";
import { GetError } from "src/constant";

export const ClientDetailView = ({ handleBackButtonClick, selectedRow, handleUnlistClients }) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const { individualClientInfo, getByIdLoadingState } = useSelector((state) => state?.clientProjects);

  /** hooks useState ----------------------------------------------------- **/
  const [isEditTextShown, setIsEditTextShown] = useState(false);
  const [isEditTextShownForProject, setIsEditTextShownForProject] = useState(false);
  const [open, setOpen] = useState(false);
  const [editData, seteditData] = useState(false);
  const [isUnlistClient, setIsUnlistClient] = useState(false);
  const [isUnlistProject, setIsUnlistProject] = useState(false);
  const [isGrantAppAccess, setIsGrantAppAccess] = useState(false);
  const [isRevokeAppAccess, setIsRevokeAppAccess] = useState(false);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const [isAddProjectModalFlag, setIsAddProjectModalFlag] = useState(false);
  const [isClickOnIndividualProjectManagers, setIsClickOnIndividualProjectManagers] = useState(false);
  const [selectedProjectManagersRow, setSelectedprojectManagersRow] = useState("");


  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    getClientByIdData();
  }, []);

  /** handler functions--------------------------------------------------- **/

  /** Function to handle image errors. -------------------------- **/
  const imgError = (image) => {
    image.onerror = "";
    image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
    return true;
  }

  /** Function to retrieve client data by ID -------------------------- **/
  const getClientByIdData = async () => {
    try {
      await dispatch(getByIdClient({ id: selectedRow?.id })).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const handleOpen = () => {
    setIsEditTextShown(false);
    setOpen(!open);
  };

  const handleUnlistClient = () => {
    setIsUnlistClient(!isUnlistClient);
  };

  const handleUnlistProject = () => {
    setIsUnlistProject(!isUnlistProject);
  };

  const handleGrantAppAccess = () => {
    setIsGrantAppAccess(!isGrantAppAccess);
  };

  const handleRevokeAppAccess = () => {
    setIsRevokeAppAccess(!isRevokeAppAccess);
  };

  const handleAddProjectModal = () => {
    setIsAddProjectModalFlag(!isAddProjectModalFlag);
  };

  const handleUnlistClientClick = () => {
    setIsUnlistClient(true);
  };

  const handleUnlistProjectClick = () => {
    setIsUnlistProject(true);
  };

  const handleGrantAppAccessClick = () => {
    setIsGrantAppAccess(true);
  };

  const handleRevokeAppAccessClick = () => {
    setIsRevokeAppAccess(true);
  };

  /** Function executes when clicking on 'Edit Client' button ---------------------- **/
  const handleEditClientClick = () => {
    setOpen(true);
    setIsEditTextShown(individualClientInfo);
  };

  /** Function executes when clicking on 'Add Project' button ---------------- **/
  const handleAddProjectButtonClick = (data) => {
    if (data) {
      seteditData(data);
      setIsEditTextShownForProject(true);
    } else {
      seteditData("")
      setIsEditTextShownForProject(false)
    }
    setIsAddProjectModalFlag(true);
  };

  /** Function executes when a single row is selected from table and saves it's respective data into the state ---------------- **/
  const handleSingleRowManagerClick = (item) => {
    setSelectedprojectManagersRow(item);
    setIsClickOnIndividualProjectManagers(!isClickOnIndividualProjectManagers);
  };

  if (getByIdLoadingState) {
    return <Loader />
  }

  return (
    <>
      <div
        className={`main-details-div-for-goodsin  ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""
          }`}
      >
        <div className="row">
          <div
            className="d-flex justify-content-center first-row-details-goodsin-page"
            onClick={() => handleBackButtonClick()}
          >
            <div className="d-flex justify-content-center align-items-center goodsin-back-icon-size">
              <img src={IconLeftArrow} alt="left arrow" />
            </div>
          </div>

          <div className="admin-details-subdiv-style">
            <div className="d-flex justify-content-between client-details-view-img-main-div">
              <div className="d-flex">
                <div className="edit-client-img-style">
                  <img alt="Client Logo"
                    className="edit-record-depot-persoanl-img"
                    src={individualClientInfo?.logoUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                    onError={imgError}
                  />
                </div>
                <div className="depotname-section ms-3 margin-top-add-class-for-client-details">
                  {individualClientInfo?.name || ""}
                </div>
              </div>
              <div className="d-flex margin-top-add-class-for-client-details">
                <span className="me-2 address-main-header-text mt-1">
                  ACTIVE SINCE
                </span>
                <span className="address-subsection text-uppercase">
                  {moment(individualClientInfo?.createdOn).format(
                    "DD-MMM-YYYY"
                  ) || ""}
                </span>
              </div>
            </div>

            <div className="add-space-margin-top-space">
              <div className="d-flex flex-column">
                <span className="address-main-header-text">ADDRESS</span>
                <div className="address-subsection">
                  {individualClientInfo?.address?.street1 ||
                    individualClientInfo?.address?.street2},&nbsp;
                  {individualClientInfo?.address?.city},&nbsp;
                  {individualClientInfo?.address?.country},&nbsp;
                  {individualClientInfo?.address?.zip}
                </div>
              </div>
            </div>

            <div className="add-space-margin-top-basic-details">
              <div className="d-flex space-header-section">
                <div className="d-flex flex-column col-md-4" style={{ paddingRight: 20 }}>
                  <span className="address-main-header-text">
                    CONTACT PERSON
                  </span>
                  <span className="address-subsection word-wrap-or-text-wrap">
                    {individualClientInfo?.contactPerson || ""}
                  </span>
                </div>
                <div className="d-flex flex-column col-md-5" style={{ paddingRight: 20 }}>
                  <span className="address-main-header-text">EMAIL</span>
                  <span className="address-subsection word-wrap-or-text-wrap">
                    {individualClientInfo?.email || ""}
                  </span>
                </div>
                <div className="d-flex flex-column col-md-3 style={{paddingRight:20}}">
                  <span className="address-main-header-text">PHONE</span>
                  <span className="address-subsection word-wrap-or-text-wrap">
                    {individualClientInfo?.phoneNumber || ""}
                  </span>
                </div>
              </div>
            </div>

            <div
              className="table-responsive edit-clientproject-table"
              style={{ width: "100%" }}
            >
              <table className="table table-borderless admintab-depots-details-table ">
                <thead className="depot-per-details-header-style">
                  <tr>
                    <th scope="col text-uppercase" style={{ minWidth: 160 }}>
                      Project Name
                    </th>
                    <th scope="col text-uppercase" style={{ minWidth: 100 }}>
                      Added on
                    </th>
                    <th scope="col text-uppercase" style={{ minWidth: 120 }}>
                      int (&#163;/ m<sup>2</sup>/ week)
                    </th>
                    <th scope="col text-uppercase">
                      ext (&#163;/ m<sup>2</sup>/ week)
                    </th>
                    <th scope="col text-uppercase" style={{ minWidth: 150 }}>
                      project manager(s)
                    </th>
                    <th scope="col text-uppercase" style={{ minWidth: 150 }}>
                      email
                    </th>
                    <th scope="col text-uppercase">phone</th>
                    <th scope="col text-uppercase">app</th>
                  </tr>
                </thead>
                <tbody>
                  {individualClientInfo?.projects?.length > 0 &&
                    individualClientInfo?.projects?.map((item, index) => {
                      let GrantAppAccess = _.uniq(
                        _.map(item?.users, (d) => d?.grantAppAccess)
                      );
                      return (
                        <React.Fragment key={index}>
                          <tr
                            className={`client-tabdetails-body-style goodsin-tr ${selectedProjectManagersRow.id == item.id
                              ? "row-border"
                              : ""
                              }`}
                            onClick={() => handleSingleRowManagerClick(item)}
                          >
                            <td
                              style={{
                                position: "relative",
                                height:
                                  isClickOnIndividualProjectManagers &&
                                    selectedProjectManagersRow.id == item.id
                                    ? 130
                                    : "auto",
                                minWidth: 160,
                              }}
                            >
                              <span>{item.name}</span>
                              {isClickOnIndividualProjectManagers &&
                                selectedProjectManagersRow.id == item.id ? (
                                <div
                                  style={{
                                    position: "absolute",
                                    display: "flex",
                                    width: 500,
                                    top: 85,
                                  }}
                                >
                                  <Button
                                    variant="outlined"
                                    className="btn-bootstrap-client-details-submit-style"
                                    style={{
                                      color: "red",
                                      borderColor: "red",
                                    }}
                                    startIcon={<CheckCircleIcon />}
                                    type="submit"
                                    onClick={handleUnlistProjectClick}
                                  >
                                    Unlist Project
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    className="btn-bootstrap-client-details-submit-style ms-2"
                                    startIcon={
                                      <img
                                        src={IconEditRecord}
                                        width={17}
                                        height={17}
                                        alt="new"
                                      ></img>
                                    }
                                    type="submit"
                                    onClick={() =>
                                      handleAddProjectButtonClick(item)
                                    }
                                  >
                                    Edit Project
                                  </Button>
                                  {
                                    item?.users?.length > 0 ?
                                      !(
                                        GrantAppAccess?.length > 0 &&
                                        GrantAppAccess[0]
                                      ) ? (
                                        <Button
                                          variant="outlined"
                                          className="btn-bootstrap-client-details-grantapp-submit-style ms-2"
                                          startIcon={
                                            <img
                                              src={IconKey}
                                              width={17}
                                              height={17}
                                              alt="new"
                                            ></img>
                                          }
                                          type="submit"
                                          onClick={handleGrantAppAccessClick}
                                        >
                                          Grant app access
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="outlined"
                                          className="btn-bootstrap-client-details-revokeapp-submit-style ms-2"
                                          startIcon={
                                            <img
                                              src={IconLock}
                                              width={17}
                                              height={17}
                                              alt="new"
                                            ></img>
                                          }
                                          type="submit"
                                          onClick={handleRevokeAppAccessClick}
                                        >
                                          Revoke app access
                                        </Button>
                                      ) : ""}
                                </div>
                              ) : (
                                ""
                              )}
                            </td>
                            <td>
                              {" "}
                              <span>
                                {moment(item.createdOn).format("DD-MMM-YY")}
                              </span>
                            </td>
                            <td>
                              {" "}
                              <span>{item.interiorPrice}</span>
                            </td>
                            <td>
                              {" "}
                              <span>{item.exteriorPrice}</span>
                            </td>
                            <td>
                              {_.map(item?.users || [], (d) => {
                                return (
                                  <div>
                                    {d.firstName} {d.lastName}
                                  </div>
                                );
                              })}
                            </td>
                            <td>
                              {_.map(item?.users || [], (d) => {
                                return <div>{d.email} </div>;
                              })}
                            </td>
                            <td>
                              {_.map(item?.users || [], (d) => {
                                return <div>{d.phoneNumber} </div>;
                              })}
                            </td>
                            <td>
                              <div
                                className={`${GrantAppAccess?.length > 0 &&
                                  GrantAppAccess[0]
                                  ? "green-color-for-web-app-sts"
                                  : "red-color-for-web-app-sts"
                                  }`}
                              >
                                {GrantAppAccess?.length > 0 && GrantAppAccess[0]
                                  ? "ON"
                                  : "OFF"}
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="client-details-btn-style">
              <div className="d-flex mt-3 justify-content-between align-items-center">
                <div className="d-flex">
                  <div className="me-4">
                    <Button
                      variant="outlined"
                      className="btn-bootstrap-submit-style"
                      style={{ color: "red", borderColor: "red" }}
                      startIcon={
                        <img
                          src={IconRemove}
                          width={15}
                          height={15}
                          alt="new"
                        ></img>
                      }
                      onClick={handleUnlistClientClick}
                    >
                      Unlist Client
                    </Button>
                  </div>

                  <div>
                    <Button
                      variant="outlined"
                      className="btn-bootstrap-submit-style"
                      startIcon={
                        <img
                          src={IconEditRecord}
                          width={17}
                          height={17}
                          alt="new"
                        ></img>
                      }
                      type="submit"
                      onClick={handleEditClientClick}
                    >
                      Edit Client
                    </Button>
                  </div>
                </div>

                <div className="me-1">
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style"
                    startIcon={
                      <img
                        src={IconAddProject}
                        width={17}
                        height={17}
                        alt="new"
                      ></img>
                    }
                    type="submit"
                    onClick={() => handleAddProjectButtonClick()}
                  >
                    Add Project
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className=" first-row-details-goodsin-page"></div>
        </div>
      </div>

      <CommonModal togal={isUnlistClient} toggleHandler={handleUnlistClient}>
        <UnlistClientForm
          individualClientInfo={individualClientInfo}
          handleUnlistClient={handleUnlistClients}
          setIsUnlistClient={handleUnlistClient}
        />
      </CommonModal>

      <CommonModal togal={isUnlistProject} toggleHandler={handleUnlistProject}>
        <UnlistProjectForm
          getAllData={getClientByIdData}
          selectedProjectManagersRow={selectedProjectManagersRow}
          setIsUnlistProject={handleUnlistProject}
          clientInfo={individualClientInfo}
        />
      </CommonModal>

      <CommonModal
        togal={isGrantAppAccess}
        toggleHandler={handleGrantAppAccess}
      >
        <GrantAppAccessForm
          getAllData={getClientByIdData}
          individualClientInfo={individualClientInfo}
          selectedProjectManagersRow={selectedProjectManagersRow}
          setIsGrantAppAccess={handleGrantAppAccess}
        />
      </CommonModal>

      <CommonModal
        togal={isRevokeAppAccess}
        toggleHandler={handleRevokeAppAccess}
      >
        <RevokeAppAccessForm
          getAllData={getClientByIdData}
          individualClientInfo={individualClientInfo}
          selectedProjectManagersRow={selectedProjectManagersRow}
          setIsRevokeAppAccess={handleRevokeAppAccess}
        />
      </CommonModal>

      <CommonModal
        togal={isAddProjectModalFlag}
        toggleHandler={handleAddProjectModal}
      >
        <AddProjectForm
          setIsEditTextShownForProject={setIsEditTextShownForProject}
          isEditTextShownForProject={isEditTextShownForProject}
          editData={editData}
          getAllData={getClientByIdData}
          individualClientInfo={individualClientInfo}
          setIsAddProjectModalFlag={handleAddProjectModal}
        />
      </CommonModal>

      <CommonModal togal={open} toggleHandler={handleOpen}>
        <AddClientForm
          setIsEditTextShown={setIsEditTextShown}
          isEditTextShown={isEditTextShown}
          setOpen={handleOpen}
          editData={individualClientInfo}
          fetchData={() => getClientByIdData()}
        />
      </CommonModal>
    </>
  );
};
